import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import CarpetServicePage from '../pages/services/carpet/page';
import AboutPage from '../pages/about/page';
import FreeholdLocationPage from '../pages/location/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services/carpet',
    element: <CarpetServicePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/location/freehold-nj',
    element: <FreeholdLocationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
